'use strict';

angular.module('aricModule', [
    'governanceProcessModule'
]);